import {FC, useState} from 'react';
//import {twoStepAuthenticationStyles} from './TwoStepAuthentication.styles';
import QrCodeStep from './TwoStepAuthenticationModalStep1';
import PasswordStep from './TwoStepAuthenticationModalStep2';
import SuccessStep from './TwoStepAuthenticationModalStep3';
import {ITwoFactorSetupResponse} from '@/utils/types/superAdmin.interface';
import {toast} from 'react-toastify';

interface TwoStepAuthenticationProps {
  onCloseModal: () => void;
}

export enum Steps {
  PASSWORD = 1,
  QR = 2,
  SUCCESS = 3,
}

const TwoStepAuthenticationWrapper: FC<TwoStepAuthenticationProps> = ({onCloseModal}) => {
  const [step, setStep] = useState(Steps.PASSWORD);
  const [setupData, setSetupData] = useState<ITwoFactorSetupResponse | null>(null);

  const handleSetupDone = (data: ITwoFactorSetupResponse) => {
    setSetupData(data);
    setStep(Steps.QR);
  };

  const handleExpired = () => {
    setSetupData(null);
    setStep(Steps.PASSWORD);
    toast.error('Setup session expired. Please try again.');
  };

  switch (step) {
    case Steps.QR:
      return setupData ? (
        <QrCodeStep
          setupData={setupData}
          onClose={onCloseModal}
          onConfirmed={() => setStep(Steps.SUCCESS)}
          onExpired={handleExpired}
        />
      ) : null;
    case Steps.SUCCESS:
      return <SuccessStep onClose={onCloseModal} />;
    default:
      return <PasswordStep onClose={onCloseModal} onSetupDone={handleSetupDone} />;
  }
};

export default TwoStepAuthenticationWrapper;
